import { SuspensePage } from '@/shared/ui/layout/SuspensePage';
import { PagesRoleEditMain } from './modules/ui/Main';

const RoleEditPage = (
  <SuspensePage>
    <PagesRoleEditMain />
  </SuspensePage>
);

export default RoleEditPage;
